import { Select, Creatable, Async } from 'components/pure/form-fields/Select';

import FormComponent from './FormComponent';

export default class SelectForm extends FormComponent {
  static Pure = ({ async: asyncronous, creatable, options, ...props }) => {
    const [Component, optionsProp] = asyncronous ? [Async, { loadOptions: options }] : [creatable ? Creatable : Select, { options }]

    return <Component
      {...props}
      {...optionsProp}
    />
  }
}

SelectForm.extendDefaultProps = {
  defaultClassName: 'form-control border-0 p-0',
}
